(function($, viewport) {
  $(function() {
    // =========================================
    // Detect for OLD Android device is < 4.4
    // so offcanvas nav can be handled properly
    // =========================================

    var md = new MobileDetect(window.navigator.userAgent);
    var device = md.os();
    var osVersion = md.version('Android');

    if (device === 'AndroidOS' && osVersion < 4.4) {
      $('body').addClass('old-android');
    }

    if (device === 'AndroidOS' || device === 'iOS') {
      $('body').addClass('mobile-device');
    }

    // =========================================
    // Prevent default on hamburger
    // =========================================
    /*
    $('#js-mobile-nav-button').click(function(e) {
        var $body = $('body');
        if ($body.hasClass('pushy-open-right')) {
            $body.removeClass('pushy-open-right');
            this.setAttribute("aria-expanded", "false");
        } else {
            //pushy-open-right added by pushy.js
            this.setAttribute("aria-expanded", "true");
        }
    });
    */

    // =========================================
    // Move primary nav
    // =========================================

      /*
    var moveUtilityNav = function () {
        if (!$('body').hasClass("lock-utility")) {
            // lock-utility is set by the _CustomerSiteLayout if all add-ons are active
            if (viewport.is('<lg')) {
                $('body').addClass('affix-to-bottom');
            } else {
                $('body').removeClass('affix-to-bottom');
            }
        }
        if (viewport.is('<lg')) {
            $('#utility').insertAfter($('.header-wrapper'));
        } else {
            // put primary-nav in orignal position
            $('#utility').insertAfter($('#large-screen-nav'));
        }
    };
      */

    // =========================================
    // Execute on initial load
    // =========================================
    //moveUtilityNav();

    // =========================================
    // BEGIN - bootstrap breakpoints
    // =========================================

    // Executes only in XS breakpoint
    //if(viewport.is('xs')) {

    //    // ...

    //}

    //// Executes in SM, MD and LG breakpoints
    //if(viewport.is('>=sm')) {

    //    // ...

    //}

    //// Executes in XS and SM breakpoints
    //if(viewport.is('<md')) {

    //    // ...

    //}

    // Execute code each time window size changes
    //$(window).resize(
      //viewport.changed(function() {
        //moveUtilityNav();

        //if(viewport.is('>=md')) {

        //    // ...

        //}

        //if(viewport.is('>sm')) {

        //    // ...

        //}
      //})
    //);
  });
})(jQuery, ResponsiveBootstrapToolkit);